import React from "react";
import { Marker, OverlayView, OverlayViewF } from '@react-google-maps/api';
import { connect } from "react-redux";
import { VehicletypesMonitoringDriversAction, TrackOrderDriverAction, GetDriverInfoAction, GetDriverOrderListAction } from "../../../../Redux/actions/actions";
// import { Marker as LeafletMarker } from "leaflet-rotatedmarker";
import { CanTrackDriver, getBaseTrackByUrl } from "../../../../helper/module";
import deliveryProfile from "../../../../assets/delivery-man.png";
import Pin from "../Pin";

import { SetActiveDriverList, SetDriverListOpenDialoge, SetDriverLocation, SetDriverPopUp } from "../../../../Redux/actions/actionNames";

const createtIcon = (data) => {
  return <Pin hasActiveOrder={true} isOnline={data.isOnline} driver={data} style={{marginTop:"-67px",marginLeft:"-39px",marginBottom:"9px"}} />
};

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      location: null,
      last_location: null,
      deg: 0,
    };
    this.intervall = null;
  }

  componentDidMount() {
    console.log("fefewff ef " , this.props.routeDetails)
    if (this.props.routeDetails && this.props.routeDetails?.route.status ==  "Started") {
      this.props.dispatch(GetDriverInfoAction(this.props.dispatch, this.props.routeDetails?.route?.driver?.id, (call) => {
         this.setState({
          data: call,
          location: call.location,
        });
      }))
      this.intervall = setInterval(() => {
        this.props.dispatch(GetDriverInfoAction(this.props.dispatch, this.props.routeDetails?.route?.driver?.id, (call) => {
          this.setState({
           data: call,
           location: call.location,
         });
       }))
      }, 5000);
    }
  }

  componentWillReceiveProps(nextProps) {
 
    if (nextProps.routeDetails && nextProps.routeDetails?.route.status ==  "Started" && !this.intervall) {

      this.props.dispatch(GetDriverInfoAction(nextProps.dispatch, nextProps.routeDetails?.route?.driver?.id, (call) => {
        this.setState({
         data: call,
         location: call.location,
       });
     }))

      this.intervall = setInterval(() => {
        this.props.dispatch(GetDriverInfoAction(nextProps.dispatch, nextProps.routeDetails?.route?.driver?.id, (call) => {
          this.setState({
           data: call,
           location: call.location,
         });
       }))
      }, 5000);
    } else if(nextProps.routeDetails?.route.status !=  "Started" && (this.intervall )) {
 
      clearInterval(this.intervall);
    }
  }

  componentWillUnmount() {
    clearInterval(this.intervall);

    this.setState({
      data: null,
      location: null,
      last_location: null,
    })

  }

  openProfile=()=>{

  }

  render() {
    
    if (
     this.props.routeDetails?.route.status ==  "Started"  &&
      this.state.data && this.state.location
    ) {
      return (
        <React.Fragment>

          <OverlayViewF
            position={{
              lat: this.state.location[1],
              lng: this.state.location[0],
            }}
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          >
            {/* {createtIcon(this.state.data)} */}
            <Pin hasActiveOrder={true} onClick={this.openProfile} isOnline={this.state.data.isOnline} driver={this.state.data} style={{marginTop:"-67px",marginLeft:"-39px",marginBottom:"9px"}} />
          </OverlayViewF>
          
        </React.Fragment>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state, ownProps) => ({
  OpenVRDialoge: state.ViewTravel.OpenDialoge,
  pureData: ownProps.VRpureData,
  type: state.ViewTravel.pureData ? state.ViewTravel.pureData.type : "",
  status: state.ViewTravel.pureData ? state.ViewTravel.pureData.status : "",
  id: state.ViewTravel.ID,
  socket: state.Socket.socket,
  driver_location: state.ViewTravel.driver_location,
  driverId: state.ViewTravel.pureData ? state.ViewTravel.pureData.driverId : "",
  activeDriver: state.DriversList.activeDriver,
  cursor: state.OrderList.cursor,
  cursorSort: state.OrderList.cursorSort,
  routeDetails : ownProps.routeDetails
});
const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
});
export default connect(mapStateToProps, mapDispatchToProps)(App);
